'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  z-index: 20;\n  display: block;\n  overflow: hidden;\n\n  ', '\n'], ['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  z-index: 20;\n  display: block;\n  overflow: hidden;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      height: 20px !important;\n      width: 20px !important;\n      border-radius: 4px;\n      transition: all 0.5s ease-in;\n      border: solid 3px white;\n      bottom: 30px;\n      left: 30px;\n      opacity: 0;\n    '], ['\n      height: 20px !important;\n      width: 20px !important;\n      border-radius: 4px;\n      transition: all 0.5s ease-in;\n      border: solid 3px white;\n      bottom: 30px;\n      left: 30px;\n      opacity: 0;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n'], ['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Helper Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var animate = _ref.animate;
  return animate && (0, _styledComponents.css)(_templateObject2);
});

var Img = _styledComponents2.default.img(_templateObject3);

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Image);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Image.__proto__ || Object.getPrototypeOf(Image)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      animate: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Image, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          src = _props.src,
          onRemove = _props.onRemove;
      setTimeout(function () {
        _this2.setState({
          animate: true
        });

        setTimeout(function () {
          return onRemove(src);
        }, 505);
      }, 200);
    }
  }, {
    key: 'render',
    value: function render() {
      var src = this.props.src;
      var animate = this.state.animate;
      return _react2.default.createElement(Container, {
        animate: animate
      }, _react2.default.createElement(Img, {
        src: src
      }));
    }
  }]);

  return Image;
}(_react.Component);

Image.propTypes = {
  src: _propTypes2.default.string,
  onRemove: _propTypes2.default.func
};
exports.default = Image;